// extracted by css-extract-rspack-plugin
export default {"crossReferencesList":"CrossReferencedEvent-module__crossReferencesList__T5acTbt"};